import { render, staticRenderFns } from "./PlacesList - 副本.vue?vue&type=template&id=e1313fa0&"
import script from "./PlacesList - 副本.vue?vue&type=script&lang=js&"
export * from "./PlacesList - 副本.vue?vue&type=script&lang=js&"
import style0 from "./PlacesList - 副本.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection,QItemLabel})
